export const getImageMap = (baseUrl) => ({
    '01d': `${baseUrl}/assets/images/common/weather/sun.svg`,
    '01n': `${baseUrl}/assets/images/common/weather/sun.svg`,
    '02d': `${baseUrl}/assets/images/common/weather/partly-cloudy-night.svg`,
    '02n': `${baseUrl}/assets/images/common/weather/partly-cloudy-night.svg`,
    '03d': `${baseUrl}/assets/images/common/weather/mostlycloudy.svg`,
    '03n': `${baseUrl}/assets/images/common/weather/mostlycloudy.svg`,
    '04d': `${baseUrl}/assets/images/common/weather/mostlycloudy.svg`,
    '04n': `${baseUrl}/assets/images/common/weather/mostlycloudy.svg`,
    '09d': `${baseUrl}/assets/images/common/weather/heavy-rain-shower.svg`,
    '09n': `${baseUrl}/assets/images/common/weather/heavy-rain-shower.svg`,
    '10d': `${baseUrl}/assets/images/common/weather/rain.svg`,
    '10n': `${baseUrl}/assets/images/common/weather/rain.svg`,
    '11d': `${baseUrl}/assets/images/common/weather/thunderstorm.svg`,
    '11n': `${baseUrl}/assets/images/common/weather/thunderstorm.svg`,
    '13d': `${baseUrl}/assets/images/common/weather/snow-shower.svg`,
    '13n': `${baseUrl}/assets/images/common/weather/snow-shower.svg`,
    '50d': `${baseUrl}/assets/images/common/weather/fog.svg`,
    '50n': `${baseUrl}/assets/images/common/weather/fog.svg`,
});
export const getWeatherImage = (weatherCode, imageMap) => {
    return imageMap[weatherCode];
};
//# sourceMappingURL=weather.utils.js.map